var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.184 0a4.677 4.677 0 013.493 1.4A5.135 5.135 0 0117 5.028v6.944a5.135 5.135 0 01-1.323 3.628 4.677 4.677 0 01-3.493 1.4H4.815a4.674 4.674 0 01-3.492-1.4A5.137 5.137 0 010 11.972V5.029A5.136 5.136 0 011.325 1.4 4.675 4.675 0 014.815 0zm2.583 14.7a3.892 3.892 0 00.958-2.731V5.026a3.422 3.422 0 00-3.541-3.754H4.815a3.422 3.422 0 00-3.54 3.754v6.946a3.422 3.422 0 003.54 3.753h7.369a3.434 3.434 0 002.583-1.025zM8.88 4.514l.008.007a.641.641 0 01.074.066l3.176 3.189a.638.638 0 01-.832.962l-.071-.062-2.1-2.106v5.4a.638.638 0 01-1.267.09l-.005-.086v-5.4l-2.1 2.105a.639.639 0 01-.83.063l-.072-.062a.639.639 0 01-.063-.83l.062-.071 3.185-3.2a.638.638 0 01.832-.063z",
    fill: "currentColor"
  })));
}

export default SvgUpload;